<template>

<div class="main marquees">

	<div class="promotions-heading">
		<h1><router-link to="/promotionpacks">Promotion Packs</router-link><i class="fas fa-chevron-right"></i><router-link :to="'/promotionpacks/' + push_pack_id" tag="a" class="breadcrumb">{{ push_pack_name }}</router-link><i v-if="push_pack_name" class="fas fa-chevron-right"></i>Marquees</h1>
	</div>

	<div class="filters with-save" v-if="!marquee_id">
		<label v-if="limitReached">Promotions packs are limited to {{ marqueeLimit }} marquees</label>
		<label v-else>Add a marquee to this promotion pack</label>
		<label></label><label></label>
		<div style="display: grid; grid-template-columns: 3fr 1fr 1fr; grid-gap: 1em;">
			<div class="input-with-control">
				<input type="text" class="promotions" placeholder="Search marquee library" v-model="search_text" @keyup.enter="searchMarquees()">
				<div :class="['button', 'input-go', limitReached ? 'disabled' : 'promotions']" @click="searchMarquees()"><i class="fas fa-search"></i></div>
			</div>
			<div :class="['button', browseLoading ? 'disabled' : 'promotions']" style="height: 2em; padding: 0.5em;" @click="searchMarquees('all')">{{ browseLoading ? "Loading..." : "Browse" }}</div>
			<div v-if="limitReached" class="button disabled" style="height: 2em; padding: 0.5em;">Upload New</div>
			<div v-if="!limitReached && !showDropzone" :class="['button', limitReached ? 'disabled' : 'promotions' ]" style="height: 2em; padding: 0.5em;" @click="showDropzone = !showDropzone">Upload New</div>
		</div>
		<div style="text-align: right;">{{ saveMessage }}</div>
		<div>
			<span :class="['button', saving || showDropzone ? 'disabled' : 'promotions']" style="float: right; margin: -0.5em 0 0 0;" @click="saveMarquees()">Save Marquees</span>
		</div>
	</div>

	<div v-if="showDropzone" class="dropzone-wrapper">
		<vue-dropzone ref="event_poster_image_dropzone" id="event_poster_image_dropzone" :options="dropzoneOptions" @vdropzone-success="imageUploadSuccess"></vue-dropzone>

		<div>
			<label v-if="newFileName">Assign product(s) to this marquee</label>
			<label v-else>You'll be able to assign product(s) to this new marquee<br>after you upload an image.</label>
			<div v-if="showProductSearch" class="filters" style="border-bottom: 0 none; margin: 0;">
				<div v-if="newFileName" class="input-with-control">
					<input type="text" class="promotions" placeholder="Search products" v-model="product_search_text" @keyup.enter="searchProducts()">
					<div class="button promotions input-go" @click="searchProducts()"><i class="fas fa-search"></i></div>
				</div>
			</div>

			<div v-for="(product, index) in newMarqueeProducts" :key="index" class="product-search-item">
				<div class="remove" @click="removeProduct(product.product_id)">X</div>
				<img :src="product.image_src">
				<br>{{ product.item_number }}<br>{{ product.upc }}
			</div>

			<div style="margin: 1em 0 0 0;">
				<div :class="['button', marqueeIsSavable ? 'promotions' : 'disabled']" style="display: inline-block; width: 7em; height: 2em; padding: 0.5em; margin: 0 1em 0 0;" @click="saveNewMarquee()">Save</div>
				<div class="button cancel" style="display: inline-block; width: 7em; height: 2em; padding: 0.5em; margin: 0 1em 0 0;" @click="showDropzone = !showDropzone">Cancel</div>
				<span v-if="uploadMessage">{{ uploadMessage }}</span>
			</div>

		</div>
	</div>

	<div v-if="message" class="empty-list">
		{{ message }}
		<div v-if="loading" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
	</div>

	<div v-if="marquees.length > 0" class="item-grid marquees">
		<div v-for="(marquee, index) in marquees" :key="index" class="marquee-item-grid">
			<img :src="marquee.image_src">
			<div class="caption">
				<div style="float: right;"><b>{{ marquee.upc }}</b></div>
				<div><b>{{ marquee.item_number }}</b></div>
				{{ marquee.description }} {{ marquee.available }}
			</div>
			<div class="feature-controls caption">
				<label>Dealer Price</label>
				<label>Retail Price</label>
				<label style="text-align: right;">Margin</label>
				<div>Default: ${{ marquee.current_cost }}</div>
				<div>Avg: ${{ marquee.customer_price }}</div>
				<div style="text-align: right;">{{ calculateMargin(marquee.current_cost, marquee.customer_price) }}</div>
				<input type="text" class="promotions" v-model="marquee.cost">
				<input type="text" class="promotions" v-model="marquee.price">
				<div style="text-align: right;">{{ calculateMargin(marquee.cost, marquee.price) }}</div>
			</div>
			<div>
				<label class="radio">
					<input type="radio" v-model="marquee.home_page_only" value="0">
					<span class="promotions"><i class="fas fa-check-circle"></i>Home + Catalog</span>
				</label>
				<label class="radio">
					<input type="radio" v-model="marquee.home_page_only" value="1">
					<span class="promotions"><i class="fas fa-check-circle"></i>Home Page Only</span>
				</label>
				<span class="button promotions" @click="removeMarquee(marquee)">X</span>
			</div>
		</div>
	</div>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>Marquee Search Results</h2>
			<div class="content">
				<div v-if="modalList.length < 1" class="empty-list">
					No marquees found for '{{ search_text }}'
				</div>
				<div v-else class="marquee-search-list">
					<div v-for="(marquee, index) in modalList" :key="index" @click="assingMarquee(marquee)">
						<img :src="marquee.image_src">
						<span class="caption">{{ marquee.description }}</span>
					</div>
				</div>
			</div>
			<div class="modal-controls">
				<div class="button cancel" @click="showModal = false">Cancel</div>
			</div>
		</div>
	</div>

	<div v-if="showModalProducts" class="modal">
		<div class="inner">
			<h2>Product Search Results</h2>
			<div class="content">
				<div v-if="modalList.length < 1" class="empty-list">
					No Products found for '{{ product_search_text }}'
				</div>
				<div v-else class="product-search-list">
					<div v-for="(product, index) in modalList" :key="index" @click="assignProduct(product)" class="product">
						<div class="image_wrapper">
							<img :src="product.image_src">
						</div>
						<span class="caption"><b>{{ product.item_number }}</b>: {{ product.description }}</span>
					</div>
				</div>
			</div>
			<div class="modal-controls">
				<div class="button cancel" @click="showModalProducts = false">Cancel</div>
			</div>
		</div>
	</div>

</div>
</template>

<script>
export default {
	name: 'marquees',
	props: ['push_pack_id'],
	data() {
		return {
			loading: true,
			message: 'Loading',
			push_pack_name: '',
			marquee_id: '',
			marquees: [],
			marqueeLimit: 20,
			search_text: '',
			browseLoading: false,
			showModal: false,
			modalList: [],
			saving: false,
			saveMessage: '',
			dropzoneOptions: {
				url: 'https://' + (document.location.hostname.indexOf('localhost') > -1 ? 'navigator.test' : document.location.hostname + '/navigatorapi') + '/api.php?action=upload_image',
				thumbnailWidth: 480,
				thumbnailHeight: 160,
				maxFiles: 1,
				addRemoveLinks: true,
				acceptedFiles: 'image/*',
				dictDefaultMessage: 'Drag or click to add a new image.<br>(Recommended 1800 x 600 jpg)',
				withCredentials: true,
				headers: {
					'Cache-Control': null,
					'X-Requested-With': null
				}
			},
			showDropzone: false,
			uploadingImage: false,
			uploadMessage: '',
			newFileName: '',
			newMarqueeProducts: [],
			showProductSearch: false,
			product_search_text: '',
			showModalProducts: false,
			savingNewMarquee: false
		}
	},
	created() {
		this.getList()
	},
	computed: {
		limitReached() {
			return this.marquees.length >= this.marqueeLimit
		},
		marqueeIsSavable() {
			return this.newFileName != '' && this.newMarqueeProducts.length > 0
		}
	},
	methods: {
		getList() {
			this.marquees = []
            this.loading = true
            this.message = 'Loading'
            this.apiCall({ destination: 'get_list_push_pack_marquees', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                this.loading = false
                this.message = obj.message
                if (obj.status == 'success') {
					this.push_pack_name = obj.push_pack_name
                    this.marquees = obj.marquees
                    if (this.marquees.length < 1) {
                        this.message = 'No marquees set for this promotion pack'
                    }
					if (obj.marquee_limit) {
						this.marqueeLimit = obj.marquee_limit
					}
                }
            })
		},
		calculateMargin(cost, price) {
			if (cost > 0 && price > 0) {
				return (100 * (1 - (Number(cost) / Number(price)))).toFixed(1) + '%'
			} else {
				return ''
			}
		},
		imageUploadSuccess(file, response) {
			let obj = JSON.parse(response)
			this.uploadMessage = obj.message
			if (obj.status == 'success') {
				this.newFileName = obj.file_name
				// get a product id
				this.showProductSearch = true
			}
		},
		searchMarquees(searchScope) {
			if (searchScope != 'all' && !this.search_text) { return }
			if (this.limitReached) { return }
			if (searchScope == 'all') {
				this.search_text = ''
				this.browseLoading = true
			}
			var marqueeIds = []
			for (var i = 0; i < this.marquees.length; i++) {
				marqueeIds.push(this.marquees[i]['marquee_id'])
			}
			this.apiCall({ destination: 'get_list_marquees', data: { search_text: this.search_text, ignore_ids: marqueeIds } }).then(obj => {
				this.showModal = true
				this.modalMessage = obj.message
				this.modalList = obj.marquees
				this.browseLoading = false
			})
		},
		assingMarquee(marquee) {
			for (var i = 0; i < this.marquees.length; i++) {
				if (this.marquees[i]['marquee_id'] == marquee.marquee_id) {
					return
				}
			}
			this.marquees.push(marquee)
			this.message = ''
			this.showModal = false
			this.modalList = []
		},
		removeMarquee(marquee) {
			for (var i = 0; i < this.marquees.length; i++) {
				if (this.marquees[i]['marquee_id'] == marquee.marquee_id) {
					this.marquees.splice(i, 1)
					break
				}
			}
		},
		saveMarquees() {
			if (this.saving || this.showDropzone) { return }
			this.saving = true
			this.apiCall({ destination: 'save_push_pack_marquees', data: { push_pack_id: this.push_pack_id, marquees: this.marquees } }).then(obj => {
				this.saving = false
                this.saveMessage = obj.message
				setTimeout(() => { this.saveMessage = '' }, 3000)
			})
		},
		searchProducts() {
			if (!this.product_search_text) { return }
			this.apiCall({ destination: 'get_list_products', data: { search_text: this.product_search_text } }).then(obj => {
				if (obj.products.length == 1) {
					this.assignProduct(obj.products[0])
				} else {
					this.showModalProducts = true
					this.modalMessage = obj.message
					this.modalList = obj.products
				}
			})
		},
		assignProduct(product) {
			var alreadyInSet = false
			for (var i = 0; i < this.newMarqueeProducts.length; i++) {
				if (this.newMarqueeProducts[i].product_id == product.product_id) {
					alreadyInSet = true
					this.product_search_text = product.item_number + ' already set!'
					break
				}
			}
			if (!alreadyInSet) {
				this.newMarqueeProducts.push(product)
				this.showModalProducts = false
				this.modalList = []
				this.product_search_text = ''
			}
		},
		removeProduct(productId) {
			for (var i = 0; i < this.newMarqueeProducts.length; i++) {
				if (this.newMarqueeProducts[i].product_id == productId) {
					this.newMarqueeProducts.splice(i, 1)
					break
				}
			}
		},
		saveNewMarquee() {
			if (this.savingNewMarquee || (this.newMarqueeProducts.length < 1 && !this.newFileName)) { return }
			this.savingNewMarquee = true
			this.apiCall({ destination: 'save_new_marquee', data: { push_pack_id: this.push_pack_id, file_name: this.newFileName, products: this.newMarqueeProducts, context: 'MARQUEE' } }).then(obj => {
				this.savingNewMarquee = false
				if (obj.status == 'success') {
					this.showDropzone = false
					this.product_search_text = ''
					this.newMarqueeProducts = []
					this.newFileName = ''
					this.getList()
				} else {
					this.uploadMessage = obj.message
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.dropzone-wrapper {
	min-height: 200px;
	margin: 1em 0 1em 0;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 1em;
}
.dropzone {
	padding: 0;
}
.product-search-item {
	display: inline-block;
	// width: 9em;
	text-align: center;
	font-size: 0.66em;
	img { max-width: 7em; max-height: 7em; }
	border: 1px solid #ccc;
	padding: 0.25em 0.5em;
	margin: 0 0.5em 0.5em 0;
	position: relative;
	.remove {
		position: absolute;
		top: 0; right: 0;
		padding: 0 0.25em;
		font-weight: bold;
		cursor: pointer;
	}
}
// .vue-dropzone {
// 	width: 1120px;
// 	min-height: 400px;
// }
// .dropzone .dz-preview {
// 	margin: 0;
// 	height: 360px;
// 	width: 1080px;
// }
</style>
